/**
 * @generated SignedSource<<afa262f292c8877306be3e24ea34e645>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateEngagementInput = {
  assetTags?: ReadonlyArray<any> | null | undefined;
  budget?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  company?: string | null | undefined;
  customerId?: string | null | undefined;
  details: string;
  email?: string | null | undefined;
  interests: ReadonlyArray<string>;
  modelFileIds?: ReadonlyArray<string> | null | undefined;
  name?: string | null | undefined;
  phone?: string | null | undefined;
  projectName?: string | null | undefined;
  scanDetails?: ScanDetailsInput | null | undefined;
  startsOn?: any | null | undefined;
  talentSlugs?: ReadonlyArray<string> | null | undefined;
  wantsConsultation?: boolean | null | undefined;
};
export type ScanDetailsInput = {
  accuracy?: string | null | undefined;
  location?: string | null | undefined;
  notes?: string | null | undefined;
  objectCount?: number | null | undefined;
  objectSize?: string | null | undefined;
  purpose?: ReadonlyArray<string> | null | undefined;
  surfaces?: ReadonlyArray<string> | null | undefined;
};
export type EngagementBuilderSubmitMutation$variables = {
  input: CreateEngagementInput;
};
export type EngagementBuilderSubmitMutation$data = {
  readonly createEngagement: {
    readonly engagement: {
      readonly id: string;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly message: string;
    }>;
  } | null | undefined;
};
export type EngagementBuilderSubmitMutation = {
  response: EngagementBuilderSubmitMutation$data;
  variables: EngagementBuilderSubmitMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateEngagementPayload",
    "kind": "LinkedField",
    "name": "createEngagement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Engagement",
        "kind": "LinkedField",
        "name": "engagement",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EngagementBuilderSubmitMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EngagementBuilderSubmitMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9abf7383075de6c309c8c957d8420019",
    "id": null,
    "metadata": {},
    "name": "EngagementBuilderSubmitMutation",
    "operationKind": "mutation",
    "text": "mutation EngagementBuilderSubmitMutation(\n  $input: CreateEngagementInput!\n) {\n  createEngagement(input: $input) {\n    engagement {\n      id\n    }\n    userErrors {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eabaf995a6eb5b8696c6196be91a2290";

export default node;
